import { Component, Input, ViewEncapsulation, ViewChild } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';
import Quill from 'quill'; // Importa Quill si no lo tienes ya
import Delta from 'quill-delta'; // Importa Delta correctamente

@Component({
  selector: 'text-wyswyg',
  templateUrl: './text-wyswyg.component.html',
  styleUrls: ['./text-wyswyg.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TextWyswygComponent extends ElementComponent {  
  @Input() override data: any = {
    text: ''
  }

  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      // ['blockquote', 'code-block'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'align': [] }],
      ['clean'],                           // remove formatting button
    ],
  };

  editorInit(quill: any){
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
      if(node.tagName == 'IMG'){
        return new Delta();
      }
      return delta;
    });

    quill.root.addEventListener('drop', (event: DragEvent) => {
      if (event.dataTransfer && event.dataTransfer.files) {
        const files = event.dataTransfer.files;
        for (let i = 0; i < files.length; i++) {
          if (files[i].type.startsWith('image/')) {
            event.preventDefault();
            return;
          }
        }
      }
    });
  }
}
